import { useCallback, useState } from "react";

import { SELECTED_LANGUAGE } from "../constants";

export default function useActiveLanguage() {
  const [activeLanguage, _setActiveLanguage] = useState<number>(
    Number(window.localStorage.getItem(SELECTED_LANGUAGE))
  );

  const setActiveLanguage = useCallback((languageId: number) => {
    window.localStorage.setItem(SELECTED_LANGUAGE, languageId.toString());
    _setActiveLanguage(languageId);
  }, []);

  return [activeLanguage, setActiveLanguage] as const;
}
